import Vue from "vue";
import store from '../store'
import VueRouter from "vue-router";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
Vue.use(VueRouter);
import Layout from "../views/Layout.vue";
import channelManageRouter from "./moudle/channelManageRouter";
import collectionManageRouter from "./moudle/collectionManageRouter";
import resourceManageRouter from "./moudle/resourceManageRouter";
import toolsManageRouter from "./moudle/toolsManageRouter";
import unlockManageRouter from "./moudle/unlockManageRouter";
import configManageRouter from './moudle/configManageRouter'
let fatherRoutes = new Map([
  ['渠道管理',channelManageRouter], 
  ['集合管理',collectionManageRouter], 
  ['资源管理', resourceManageRouter],
  ['解锁管理',unlockManageRouter], 
  ['配置',configManageRouter], 
  ['操作', toolsManageRouter],
])
const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue")
  }
];

function findChildRoleInfo(roleInfo, child) {
  const aliases = (child.meta && child.meta.menuAliases) || []
  return (roleInfo || []).find(
    (info) => info.name === child.name || aliases.includes(info.name)
  )
}

function getRoleRoutes(roles) {
  const routes = [];
  roles.forEach(fatherElement => {
    const tree = fatherRoutes.get(fatherElement.name);
    if(!tree)return
    const children = tree.children;// route_tree的children
    const roleInfo = fatherElement.children;//组内childern权限
    const allNotAuth = roleInfo.every(childInfo => childInfo.role === 0);//判断一个组内是否都是0权限
    if (!allNotAuth) {
      const filteredChildren = children.filter(child => {
        const childInfo = findChildRoleInfo(roleInfo, child);
        if (!childInfo||childInfo.role==0) {
          return false;
        }
        if (childInfo.role === 1&&child.children&&child.children.length>0) {
          const filteredPages = child.children.filter(page => {
            return !/create|edit|resourcesCreate/.test(page.path);
          });
          child.children = filteredPages;
          return true;
        }
        return true;
      })
      filteredChildren.forEach(child => {
        const childInfo = findChildRoleInfo(roleInfo, child);
        if (childInfo) {
          child.key=childInfo.role
          child.meta = {
            ...child.meta,
            role: childInfo.role
          };
          if (child.children && child.children.length > 0) {
            child.children.forEach(page => {
              page.key=childInfo.role
              page.meta = {
                ...page.meta,
                role: childInfo.role
              };
            });
          }
        }
      });
      tree.children = filteredChildren;
      routes.push(tree);
    }
  });
  return routes;
}
function getRedirect(children){
  let redirect=children[0].path
  for (let i = 0; i < children.length; i++) {
    let element = children[i];
    if(element.redirect){
      const childs=element.children
      if(childs&&childs.length>0){
          let element = childs[0];
          redirect=element.path
          break
      }
    }else{
      redirect=element.path
      break
    }
  }
  return redirect
}

export function userRoutes(roles){
  routes.splice(1);
  const children=getRoleRoutes(roles)
  let redirect=getRedirect(children)
  const authRoutes=[
    {
      path: "/",
      name: "Layout",
      component: Layout,
      redirect: redirect,
      children:children
    },
    {
      path: "*",
      name: "404",
      component: () => import("../views/404.vue")
    }
  ]
  // 将动态路由配置添加到路由表中
  router.matcher.addRoutes(authRoutes);

  // 将动态路由配置保存到你的数据中，以便其他地方使用
  routes.push(...authRoutes);
}

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, form, next) => {
  NProgress.start();
  // 判断登陆
  if (store.getters['user/getToken']) {
    // 解决路由懒加载导致的页面刷新问题
    let formLen=form.matched.length
    let toLen=to.matched.length
    let formParams=JSON.stringify(form.params)
    let toParams=JSON.stringify(to.params.id)
    if(formLen>0&&toLen>0&&form.matched[form.matched.length-1].path==to.matched[to.matched.length-1].path&&formParams!==toParams){
      window.location.reload()
    }
    next();
    NProgress.done();
    if(to.path=='/login'){
      localStorage.removeItem('user_info')
    }   
  }else{
    if (to.path !== "/login") {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else{
      next();
    }
    NProgress.done();
    localStorage.removeItem('user_info')
  } 
  
});
export default router;
